/* eslint-disable react/prefer-stateless-function */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Quesito from './Index';

class WrapperQuesito extends Component {
  componentDidMount() {
    this.notificaQuesitoSelezionato();
  }

  componentDidUpdate() {
    this.notificaQuesitoSelezionato();
  }

  notificaQuesitoSelezionato() {
    const { quesitoSelezionato } = this.context;
    const { match } = this.props;
    quesitoSelezionato(match.params.idQuesito);
  }

  render() {
    const { router, segnaPraticaComeLetta, caricaQuesiti } = this.context;
    const {
      profilo, match, ufficioSelezionato,
    } = this.props;
    return (
      <Quesito
        urlHelpdesk={window.UrlHelpdesk}
        router={router}
        profilo={profilo}
        stato={match.params.stato}
        idQuesito={match.params.idQuesito}
        ufficioSelezionato={ufficioSelezionato}
        segnaPraticaComeLetta={segnaPraticaComeLetta}
        caricaQuesiti={() => caricaQuesiti(match.params.stato, ufficioSelezionato)}
      />
    );
  }
}

WrapperQuesito.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  profilo: PropTypes.any.isRequired,
  ufficioSelezionato: PropTypes.string.isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      stato: PropTypes.string.isRequired,
      idQuesito: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};

WrapperQuesito.contextTypes = {
  segnaPraticaComeLetta: PropTypes.func,
  caricaQuesiti: PropTypes.func,
  quesitoSelezionato: PropTypes.func,
  // eslint-disable-next-line react/forbid-prop-types
  router: PropTypes.object,
};

const mapStateToProps = (state) => ({ profilo: state.profilo, ufficioSelezionato: state.ufficioSelezionato });

export default connect(
  mapStateToProps,
  null,
)(WrapperQuesito);
